import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-639935ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-number" }
const _hoisted_2 = { class: "step-number__number" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'step-number',
  props: {
    width: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "58d634e9": (stepWidth.value)
}))

const props = __props;

const stepWidth = computed(() => {
  return props.width || "16px";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})